module.exports = __webpack_public_path__ + "img/layout1.c2406043.png";